import { Routes } from '@angular/router';

export const tradeRequestsRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./trade-requests.page').then((m) => m.TradeRequestsPage),
  },
  {
    path: ':tradeRequestId',
    loadComponent: () =>
      import('./trade-requests.page').then((m) => m.TradeRequestsPage),
  },
];
